<script>
/* eslint-disable dot-notation */
import { mapState } from 'vuex';
import CardWithBack from '@/components/app/CardWithBack.vue';

export default {
  name: 'CardIntros',

  components: {
    CardWithBack,
  },

  computed: {
    ...mapState('cards', ['previewCards']),

    deepeningCard() {
      return this.previewCards['boat'] || { category: 'deepening', text: '' };
    },

    journeyCard() {
      return this.previewCards['hot-air-balloon'] || { category: 'journey', text: '' };
    },

    lighteningCard() {
      return this.previewCards['escalator'] || { category: 'lightening', text: '' };
    },
  },
};
</script>

<template>
  <section class="section">
    <h2 class="section-title">
      Meet the 3 kinds of&nbsp;cards
    </h2>

    <h6 class="thin-font center-text">
      Take a deep breath and let your imagination fill in the details of each&nbsp;scene
    </h6>

    <div class="card-section">
      <div class="description">
        <h4 class="regular-font">
          Deepening Cards
        </h4>
        <h6 class="thin-font">
          Relax into a peaceful state
        </h6>
      </div>

      <CardWithBack :card="deepeningCard" class="right-card" />
    </div>

    <div class="card-section right-align">
      <div class="description right-description">
        <h4 class="regular-font">
          Journey Cards
        </h4>
        <h6 class="thin-font">
          Change your mood, look within, and&nbsp;be&nbsp;creative
        </h6>
      </div>

      <CardWithBack :card="journeyCard" class="left-card" />
    </div>

    <div class="card-section">
      <div class="description">
        <h4 class="regular-font">
          Lightening Cards
        </h4>
        <h6 class="thin-font">
          Boost your energy with lighthearted&nbsp;fun
        </h6>
      </div>

      <CardWithBack :card="lighteningCard" class="right-card" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.card-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding-top: 2rem;

  &.right-align {
    flex-direction: row-reverse;
  }

  .sm &,
  .md & {
    flex-direction: column;
    justify-content: flex-start;
    padding: 1rem;
    text-align: center;
  }
}

.description {
  margin: 2rem 0;
  box-sizing: border-box;

  .lg &,
  .xl & {
    max-width: calc(100% - 420px);

    &.right-description {
      padding-left: 2rem;
    }
  }
}
</style>
